import React, { useState, useRef, useEffect } from "react";
import "../assets/css/carQuestion.css";
import { Spin } from "antd";

import einstinaudio from "../audio/albert-einstein.mp3";
import cleopatra from "../audio/cleopatra.mp3";
import leonardo from "../audio/leonardo-da-vinci.mp3";
import akira from "../audio/akira-flame.mp3";
import alice from "../audio/alice-from-wonderland.mp3";
import thewisementor from "../audio/the-wise-mentor.mp3";
import theadventurer from "../audio/the-adventurer.mp3";
import protectivedragon from "../audio/protective-dragon.mp3";
import janeausten from "../audio/jane-austen.mp3";
import nikolatesla from "../audio/nikola-tesla.mp3";
import maleneighbor from "../audio/male-neighbor.mp3";
import femaleneighbor from "../audio/female-neighbor.mp3";
import themechanic from "../audio/the-mechanic.mp3";
import robinhood from "../audio/robin-hood.mp3";
import racing from "../audio/racing-legend.mp3";
import thetrickster from "../audio/the-trickster.mp3";
import atlas from "../audio/atlas.mp3";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const personalityOptions = [
  {
    value: "INTJ-M",
    name: "Atlas",
    label: "Atlas (Analytical, strategic, logical)",
    audio: atlas,
  },
  {
    value: "INTP-M",
    name: "Albert Einstein",
    label: "Albert Einstein (Theorist, thinker, problem-solver)",
    audio: einstinaudio,
  },
  {
    value: "INFP-F",
    label: "Alice Wonderland (Imaginative, idealistic, dreamer)",
    name: "Alice from Wonderland",
    audio: alice,
  },
  {
    value: "ENTJ-F",
    name: "Cleopatra",
    label: "Cleopatra (Leader, decisive, commanding)",
    audio: cleopatra,
  },
  {
    value: "INFJ-F",
    label: "Akira Flame (Optimistic, purpose-driven, empathetic)",
    name: "Akira Flame",
    audio: akira,
  },
  {
    value: "ESFJ-F",
    label: "The Female Neighbor (Warm, social, helpful)",
    name: "Female Neighbor",
    audio: femaleneighbor,
  },
  {
    value: "ISFJ-F",
    label: "Jane Austen (Supportive, considerate, nurturing)",
    name: "Jane Austen",
    audio: janeausten,
  },
  {
    value: "ENTP-M",
    name: "Leonardo da Vinci",
    label: "Leonardo da Vinci (Inventive, curious, original thinker)",
    audio: leonardo,
  },
  {
    value: "ESFJ-M",
    label: "The Male Neighbor (Warm, social, helpful)",
    name: "Male Neighbor",
    audio: maleneighbor,
  },
  {
    value: "ESTJ-M",
    label: "Nikola Tesla (Organized, efficient, gets things done)",
    name: "Nikola Tesla",
    audio: nikolatesla,
  },
  {
    value: "ISTJ-M",
    label: "The Dragon (Loyal, protective beast)",
    name: "Protective Dragon",
    audio: protectivedragon,
  },

  {
    value: "ESTP-M",
    label: "Racing Legend (Action-oriented, thrill-seeker, bold)",
    name: "Racing Legend",
    audio: racing,
  },
  {
    value: "ISFP-M",
    label: "Robin Hood (Free spirit, values-driven, helper)",
    name: "Robin Hood",
    audio: robinhood,
  },

  {
    value: "ENFP-M",
    label: "The Adventurer (Energetic, enthusiastic, explorer)",
    name: "The Adventurer",
    audio: theadventurer,
  },
  {
    value: "ISTP-M",
    label: "The Mechanic (Practical, resourceful, enjoys hands-on work)",
    name: "The Mechanic",
    audio: themechanic,
  },

  {
    value: "ESFP-M",
    label: "The Trickster (Playful, fun-loving, entertainer)",
    name: "The Trickster",
    audio: thetrickster,
  },
  {
    value: "ENFJ-M",
    label: "The Wise Mentor (Supportive, inspiring, teacher)",
    name: "The Wise Mentor",
    audio: thewisementor,
  },
];

const CarPersonalityPage = () => {
  const [selected, setSelected] = useState(null);
  const [playing, setPlaying] = useState(null);
  const [loading, setLoading] = useState(false);
  const audioRefs = useRef({});
  const location = useLocation();
  const navigate = useNavigate();

  const [answer, setAnswer] = useState(location.state?.answer || {});

  // const { answer, epuid, secret } = location.state || {};

  console.log("answer", location.state);

  useEffect(() => {
    // const navigationType = performance.getEntriesByType("navigation")[0]?.type;
    // if (navigationType === "reload") {
    //   navigate("/");
    // }
    if (answer?.brand?.toLowerCase() === "cupra") {
      const dragonOption = personalityOptions.find(
        (opt) => opt.name.toLowerCase() === "protective dragon"
      );
      console.log("dragonOption", dragonOption);
      if (dragonOption) {
        setSelected(dragonOption.value);
        setAnswer((prev) => ({
          ...prev,
          mbti: dragonOption.value,
        }));
      }
    }
  }, [navigate, answer?.model]);

  const handleSubmit = async () => {
    if (!answer.mbti) return;

    setLoading(true);
    try {
      const generateImage = await axios.post(
        `${process.env.REACT_APP_END_POINT}/get_carimage`,
        { answer, epuid: location.state.epuid }
      );
      console.log("generateImage", generateImage);
      const personalityResponse = await axios.post(
        `${process.env.REACT_APP_END_POINT}/get_personality`,
        {
          epuid: location.state.epuid,
          secret: location.state.secret,
          answer,
          avatar: generateImage.data.data,
        }
      );

      console.log("location.state.secret", location.state.secret);
      console.log("location.state.epuid", location.state.epuid);
      console.log("personalityResponse", personalityResponse);
      // if (personalityResponse.status === 200) {
      //   window.open(
      //     `http://127.0.0.1:5501/metasoul-espark/soulViewer.min.html?secret=${location.state.secret}&epuId=${location.state.epuid.epuid}&persona=${answer.drivingMode}`,
      //     "_self"
      //   );
      // }
      if (personalityResponse.status === 200) {
        window.open(
          `https://metasoul.live/soulViewer.min.html?secret=${location.state.secret}&epuId=${location.state.epuid.epuid}&persona=${answer.drivingMode}`,
          "_self"
        );
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const stopAllAudio = () => {
    Object.values(audioRefs.current).forEach((audio) => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    });
    setPlaying(null);
  };

  const handleMouseEnter = (option) => {
    const audioEl = audioRefs.current[option.value];
    if (!audioEl) return;
    stopAllAudio();
    if (selected !== option.value) {
      audioEl.currentTime = 0;
      audioEl.play();
      setPlaying(option.value);
    }
  };

  const handleMouseLeave = (option) => {
    const audioEl = audioRefs.current[option.value];
    if (!audioEl) return;
    if (selected !== option.value) {
      audioEl.pause();
      audioEl.currentTime = 0;
      setPlaying(null);
    }
  };

  const handleSelect = (option) => {
    console.log("option", option);
    const audioEl = audioRefs.current[option.value];
    if (!audioEl) return;
    if (playing && playing !== option.value) stopAllAudio();
    if (playing === option.value) {
      audioEl.pause();
      audioEl.currentTime = 0;
      setPlaying(null);
    } else {
      audioEl.currentTime = 0;
      audioEl.play();
      setPlaying(option.value);
    }
    setSelected(option.value);
    setAnswer((prev) => ({
      ...prev,
      mbti: option.value,
    }));
  };

  return (
    <div className="personalityPageContainer">
      <p>
        Click once to enable sound. Hover to preview; click a vibe to choose.
      </p>
      <div className="grid">
        {personalityOptions.map((option) => (
          <figure
            key={option.value}
            className={`card ${selected === option.value ? "selected" : ""}`}
            tabIndex={0}
            onClick={() => handleSelect(option)}
            onMouseEnter={() => handleMouseEnter(option)}
            onMouseLeave={() => handleMouseLeave(option)}
          >
            <img
              src={`https://emoshape-1e72.kxcdn.com/metasoul/${option.name.replaceAll(
                " ",
                "-"
              )}.png`}
              alt={option.name}
            />
            <figcaption>
              <div className="name">{option.name}</div>
              <div className="hint">Hover or tap to hear</div>
            </figcaption>
            <audio
              ref={(el) => (audioRefs.current[option.value] = el)}
              preload="auto"
              playsInline
              src={option.audio}
            />
          </figure>
        ))}
      </div>

      <button className="nextBtn" disabled={loading} onClick={handleSubmit}>
        {/* {loading ? "Loading..." : "Submit"} */}
        {loading ? <Spin size="small" style={{ color: "white" }} /> : "Submit"}
      </button>
    </div>
  );
};

export default CarPersonalityPage;
